import { Routes, Route, Navigate } from 'react-router-dom'
import { HomePage, CheckPage, SummaryPage, ReportPage, HistoryPage, OnboardingPage } from '@/pages'
import { getDepartmentConfig } from '@/services/storage'

function HomeGuard() {
  const config = getDepartmentConfig()
  if (!config) return <Navigate to="/onboarding" replace />
  return <HomePage />
}

function App() {
  return (
    <Routes>
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/" element={<HomeGuard />} />
      <Route path="/check/:type" element={<CheckPage />} />
      <Route path="/summary" element={<SummaryPage />} />
      <Route path="/report/:id" element={<ReportPage />} />
      <Route path="/history" element={<HistoryPage />} />
    </Routes>
  )
}

export default App
